/**
 * methods for translating between geojson property values
 * and lookup table IDs.
 *
 * Map styling & filtering in particular depend on the lookup IDs
 * so be sure the lookup tables are loaded successfully
 * before doing any map stuff that uses the IDs.
 */

import * as actions from '@/constants/actions';
import axios from 'axios';

export default {
    data() {
        return {
            propertyLookups: null,
        };
    },
    methods: {
        /**
         * get geojson property lookup tables
         * to translate between ids and property values
         * @return {Object} lookups Object
         */
        async getLookupTables() {
            try {
                this.$store.dispatch(actions.ADD_LOADING, 'get map data lookup values');
                const lookupTableUrl = `${this.mapSourceUrl}/lookups.json`;
                const { data } = await axios.get(lookupTableUrl);
                this.propertyLookups = data;

                this.$store.dispatch(actions.REMOVE_LOADING, 'get map data lookup values');
            } catch (e) {
                this.$store.dispatch(actions.TRIGGER_TOAST, 'Error loading map data');
            }

            return this.propertyLookups;
        },
        /**
         * get property value from lookup id
         * @param  {String} property property name (key)
         * @param  {Number} id       id from lookup table
         * @return {String}          property value
         */
        lookupPropertyById(property, id) {
            const lookups = this.propertyLookups[property];
            return lookups[id];
        },
        /**
         * get property id from value
         * returns -1 if not found
         * @param  {String} property property name (key)
         * @param  {String} name     property value
         * @return {Number}          id from lookup table
         */
        lookupPropertyByValue(property, name) {
            const lookups = this.propertyLookups[property];
            if (!lookups) return -1;
            const id = lookups.indexOf(name);
            return id;
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/lookupGeojsonProperties.js